import { memo } from "react";
import { formattedDateTimeWithoutSec } from "../../../lib/functions";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";

interface PermitDetailsProps {
    permitDetails: {
        employeeName: string;
        s_Building: string;
        s_LaptopType: string;
        s_LaptopSerialNumber: string;
        dt_PermitStartDate: string;
        dt_PermitEndDate: string;
    };
}

const PermitDetails = ({
    permitDetails,
}: PermitDetailsProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 1: Permit Details
                </span>
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Employee Name:"
                    value={permitDetails?.employeeName || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Device Type:"
                    value={permitDetails?.s_LaptopType || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Serial Number:"
                    value={permitDetails?.s_LaptopSerialNumber || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Building:"
                    value={permitDetails?.s_Building || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Permit Start Date:"
                    value={
                        formattedDateTimeWithoutSec(
                            permitDetails?.dt_PermitStartDate
                        ) || ""
                    }
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Permit End Date:"
                    value={
                        formattedDateTimeWithoutSec(
                            permitDetails?.dt_PermitEndDate
                        ) || ""
                    }
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>
        </div>
    );
};

export default memo(PermitDetails);
